import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <ContactSection />
        <AppSection />
        <MediaSection />
        <CarouselSection />
        <CommentsSection />
        <FeaturesSection />
        <CardsSection />
        <UpdatesSection />
        <TopicsSection />
        <AboutSection />
        <FaqSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}